// extracted by mini-css-extract-plugin
export default {"Container":"payroll_Container__XY83H","section-1":"payroll_section-1__Uf7JA","content":"payroll_content__8OGvy","section-2":"payroll_section-2__s4sv8"};